import {
  GetQuickFilterStatisticsResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

export function useQuickFilterStatistics() {
  const api = useApi();

  return useQuery<GetQuickFilterStatisticsResponseDto, ExtendedAxiosError>({
    queryKey: ['quick-filter-statistics'],
    queryFn: () => api.issuesApi.getQuickFilterStatistics().then((r) => r.data),
    meta: {
      handleError: true,
    },
  });
}
